import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AswContextStoreService, AswMasterService, CommonLibService } from '@lib/services';
import { CheckinBaseComponent } from '@common/components';
import { GetFlightsResultStoreService } from '@common/services';
import { DeviceType } from '@lib/interfaces';

@Component({
  selector: 'asw-checkin-waiting-search-sub-header',
  templateUrl: './checkin-waiting-search-sub-header.component.html',
  styleUrls: ['./checkin-waiting-search-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [GetFlightsResultStoreService],
})
export class CheckinWaitingSearchSubHeaderComponent extends CheckinBaseComponent {
  constructor(
    private common: CommonLibService,
    private getFlightsResultStoreService: GetFlightsResultStoreService,
    private _aswMasterSvc: AswMasterService,
    private _aswContextStoreSvc: AswContextStoreService
  ) {
    super(common);
  }

  override reload(): void {}
  override init(): void {}

  /**
   * 戻るボタンが押下された場合イベント
   * @param event
   */
  onClickBackButton(event: Event) {
    this.getFlightsResultStoreService.clear();
    // 提携サイトに遷移する
    this.common.navigateAllSite();
  }

  override destroy(): void {}

  /**
   * ASWTOPのURL取得
   */
  public getTopUrl() {
    let topUrl = this._aswMasterSvc.getMPropertyByKey('application', 'topServer');
    if (this._aswContextStoreSvc.aswContextData.deviceType === DeviceType.PC && this.isJapanOrApfWebsite()) {
      topUrl += this._aswMasterSvc.getMPropertyByKey('application', 'topPath.pc.revenue');

      if (this._aswContextStoreSvc.aswContextData.lang !== 'ja') {
        topUrl += 'e';
      }
    } else {
      topUrl += this._aswMasterSvc.getMPropertyByKey('application', 'topPath');
    }

    return topUrl;
  }

  /**
   * 日本サイト（有償・特典）または APFサイトかの判定
   */
  public isJapanOrApfWebsite() {
    const officeCode = this._aswContextStoreSvc.aswContextData.pointOfSaleId;
    return officeCode === 'TYONH08AA' || officeCode === 'TYONH08ZZ' || officeCode === 'TYONH08AP';
  }
}
